module.exports = __webpack_public_path__ + "static/media/aqua11.a849cdc8.jpg";